import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import Consts from "../../utilities/Consts";
import * as NetworkHelper from "../../utilities/Networkhelper";

import CommonHelper from "../../utilities/CommonHelper";
import { LkDropDown } from "../../components/LkDropDown";
import { useFormik } from "formik";
import { Toolbar } from "primereact/toolbar";
import { LkCalendar } from "../../components/LkCalendar";
import DropDownHelper from "../../utilities/DropDownHelper";
import { BlockUI } from "primereact/blockui";
import { useStateValue } from "../../utilities/StateProvider";
import StringHelper from "../../utilities/StringHelper";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

export const KapaliSiparislerReport = (props) => {
  const { } = props;
  const cLabels = Consts.localizedStrings;
  const baseUrl = Consts.network.siparisler;

  const isFirstRender = useRef(true);

  const [{ user, userLanguage }, dispatch] = useStateValue();
  const [count, setCount] = useState(0);
    const [sum, setSum] = useState(0);
  const [datalist, setDatalist] = useState([]);
  const [blocked, setBlocked] = useState(false);
  const [dataTableLoading, setDataTableLoading] = useState(false);
  const [ddListSysSiparisDurum, setDdListSysSiparisDurum] = useState([]);
  const [errors, setErrors] = useState({});
  const dt = useRef(undefined);

  const formik = useFormik({
    initialValues: {
      status: 1,
      start_date: CommonHelper.firstDateOfCurrentMonth(),
      end_date: CommonHelper.lastDateOfCurrentMonth(),
    },
    validateOnChange: false,
    validateOnBlur: false,
    validate: (data) => {
      let errors = {};

      if (StringHelper.isEmpty(data.start_date)) {
        errors.start_date = cLabels.requiredField;

      }
      if (StringHelper.isEmpty(data.end_date)) {
        errors.end_date = cLabels.requiredField;

      }
      setErrors(errors);
      if (Object.keys(errors).length !== 0) {
        CommonHelper.showWarnMessage(cLabels.lutfen_girdiginiz_bigileri_kontrol_ediniz);
      }

      return errors;
    },
    onSubmit: (data) => {
      // setFormData(data);
      // StringHelper.isEmpty(data.id) ? _onCreate(data) : _update(data);
      // _list
      _list( data);

      ////formik.resetForm();
    },
  });
  useEffect(() => {
    dispatch({
      type: "SET_PAGE_HEADER",
      pageHeader: cLabels.kapali_siparisler_header,
    });
  }, [userLanguage]);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      init();
    }
  });
  const init = async () => {
    CommonHelper.setGlobalBlocked(dispatch, true);
    await Promise.all([setDdListSysSiparisDurum(await DropDownHelper.sys_siparis_durum())])
      .then((values) => {

        // test();
      })
      .catch((error) => {
        CommonHelper.handleCatch(error);
      });
    CommonHelper.setGlobalBlocked(dispatch, false);
  };
   

  const _list = async (_filters = formik.values) => {
    try {
      setDataTableLoading(true);
      let response = await NetworkHelper.call_web_service(baseUrl.siparis_with_customer_info, {
        start_date: CommonHelper.getFormatDateYYYYMMDD(formik.values.start_date),
        end_date: CommonHelper.getFormatDateYYYYMMDD(formik.values.end_date),
      });
      setDatalist(response.datalist);
       let _sum = 0;
            response.datalist.forEach(element => {
              _sum += element.s_g_toplam;
      
            });
            setCount(response.datalist.length);
            setSum(CommonHelper.toFixedCurrency(_sum));
    } catch (error) {
      console.log("._onList.catch", error);
      CommonHelper.handleCatch(error);
    } finally {
      setDataTableLoading(false);
    }
  };

  const rightContents = (
    <div className="table-header">
      <Button icon="pi pi-search" label={cLabels.search} className="p-mr-2" form="my-form" onSubmit={() => formik.handleSubmit()} />
      <Button
        className="p-mr-2"
        label={cLabels.clear}
        icon="pi pi-refresh"
        onClick={() => {
          formik.resetForm();
          setDatalist([]);
        }}
      />
    </div>
  );
 
  const header = (
    <div className="table-header">
      {cLabels.kapali_siparisler_header}
      {user.user_level == 1 && (
        <Button
          type="button"
          icon="pi pi-file-excel"
          className="p-button-success p-button-sm"
          onClick={() => {
            CommonHelper.exportExcel(dispatch, cLabels.kapali_siparisler_header, dt);
          }}
        />
      )}
    </div>
  );
    let footerGroup = (
          <div>
            {`${Consts.localizedStrings.totalCount}: ${count} - ${Consts.localizedStrings.TotalSum}: ${sum}`}
          </div>
        );
  return (
    <div className="content-section implementation datatable-filter-demo">
      <BlockUI blocked={blocked} fullScreen />

      <div className=" p-fluid p-formgrid  grid">
        <div className="col-12 md:col-6">
          <div className="card" >
            <form id="my-form" onSubmit={formik.handleSubmit} style={{ marginLeft: "20px" }}>
              <div className="p-fluid p-formgrid  grid" style={{ alignItems: 'center' }}>
                <div className="p-field  col-3">
                  <label>{cLabels.start_date+'('+cLabels.f_odeme_tar+')'}</label>
                  <LkCalendar id="start_date" formik={formik} />
                </div>
                <div className="p-field  col-3">
                  <label>{cLabels.end_date}</label>
                  <LkCalendar id="end_date" formik={formik} />
                </div>
              </div>
            </form>
            <div className="clear">
              <Toolbar right={rightContents} />
            </div>
          </div>
        </div>
      </div>
      <Divider />
      <div className="card">
        <DataTable
          reorderableColumns
          header={header}
          value={datalist}
          dataKey={"name_surname"}
          id="idx"
          rowHover
          ref={dt}
          selectionMode="single"
          className="p-datatable-sm"
          emptyMessage={cLabels.datatable_empty_mesaage}
          loading={dataTableLoading}
          stripedRows
          resizableColumns
          scrollable
          scrollHeight='calc(100vh - 450px)'
           footer={footerGroup}
        >
          <Column field="cus_name" header={cLabels.cus_name} headerStyle={{ width: "15rem" }} />
          <Column field="cus_surname" header={cLabels.cus_surname} headerStyle={{ width: "15rem" }} />
          <Column field="cus_id" header={cLabels.cus_code} />
          <Column field="s_tar" header={cLabels.s_tar} body={(rowData) => CommonHelper.dateBodyTemplate(rowData, "s_tar")} dataType="date" />
          <Column field="f_no" header={cLabels.f_no} />
          <Column field="f_tarih" header={cLabels.f_tarih} body={(rowData) => CommonHelper.dateBodyTemplate(rowData, "f_tarih")} dataType="date" />
          <Column field="s_g_toplam" header={cLabels.s_g_toplam} dataType="numeric" body={(rowData) => CommonHelper.toFixedCurrencyBold(rowData.s_g_toplam)} />
          <Column field="f_odeme_tar" header={cLabels.f_odeme_tar} body={(rowData) => CommonHelper.dateBodyTemplate(rowData, "f_odeme_tar")} dataType="date" />
          <Column field="per_name" header={cLabels.per_name} />
          <Column field="cus_firm" header={cLabels.firma} headerStyle={{ width: "15rem" }} />
          <Column field="country" header={cLabels.country_code} />
          <Column field="cus_atu_no" header={cLabels.cus_atu_no} />
        </DataTable>
      </div>
    </div>
  );
};
